var React = require('react');

function Steps (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M398.571 277.319L358.167 184.912L265.76 225.316L225.356 132.909L132.949 173.313L92.5451 80.9057L0.138065 121.31L121.35 398.531L398.571 277.319Z","fill":"#EAC057"}));
}

Steps.defaultProps = {"width":"0","height":"0","viewBox":"0 0 399 399","fill":"none","id":"steps","className":"shape"};

module.exports = Steps;

Steps.default = Steps;
